import request from '@/common/request'
import { Page } from '@/models'
import { AgGridState } from '@/models/views/AgGrid'
import { Relatorio, ViewPerfil, ViewRelatorio } from '@/models/views/ViewRelatorio'

const basePath = '/views'

export const listarViews = (): Promise<ViewRelatorio[]> =>
	request.get(`${basePath}/listar`)

export const efetuarConsultaRelatorio = (idView: string, params?: any): Promise<object[]> =>
	request.get(`${basePath}/${idView}`, {
		params,
	})

export const gerarExcel = (idView: string, params?: any): Promise<object[]> =>
	request.get(`${basePath}/gerar-excel/${idView}`, {
		params,
	})

export const listarViewPorPerfil = (idPerfil: string): Promise<ViewPerfil[]> =>
	request.get(`${basePath}/perfil/${idPerfil}/listar`)

export const salvarViewPerfis = (viewPerfis: ViewPerfil[]): Promise<void> =>
	request.post(`${basePath}/perfil/salvar`, viewPerfis)

export const listarViewsPorPerfil = (idPerfil: string): Promise<ViewRelatorio[]> =>
	request.get(`${basePath}/listar/${idPerfil}`)

export const listarRelatorios = (relatorioId: string, params?: any): Promise<Page<Relatorio>> =>
	request.get(`${basePath}/relatorios/${relatorioId}`, {
		params,
	})

export const listarOpcoesDeFiltro = (filtroId: string): Promise<string[]> =>
	request.get(`${basePath}/listar/filtro/${filtroId}/opcoes`)

export const buscarPresetsDoUsuario = (idView: string): Promise<AgGridState[]> =>
	request.get(`${basePath}/${idView}/presets-grid`)

export const salvarPreset = (presetNovo: AgGridState): Promise<void> =>
	request.post(`${basePath}/presets-grid/salvar`, presetNovo)

export const removerPreset = (presetId: string): Promise<void> =>
	request.delete(`${basePath}/${presetId}/presets-grid`)

export const compartilharPreset = (presetId: string, usuarioId: string, nome: string): Promise<void> =>
	request.post(`${basePath}/presets-grid/compartilhar?presetId=${presetId}&usuarioId=${usuarioId}&nome=${nome}`)